import get from 'lodash.get';
import { useApolloClient } from 'react-apollo';
import React, { useContext, useEffect } from 'react';
import AuthContext from './AuthContext';
import { withCookies } from 'react-cookie';
import { useLocation, useHistory } from 'react-router';
import ChannelContext from '../ChannelContext';
import { useShopConfig } from '../../hooks/useShopConfig';
const AuthProvider = function AuthProvider(props) {
    const token = get(props, 'cookies.cookies.authToken');
    const [loggedIn, setLoggedIn] = React.useState(!!token);
    const client = useApolloClient();
    const { selectedChannel } = useContext(ChannelContext);
    const { pathsWithNoAuthRequired, loginPath } = useShopConfig();
    const location = useLocation();
    const history = useHistory();
    // Redirec to login on unauthorised routes
    useEffect(() => {
        if (!selectedChannel.requiresAuth)
            return;
        if (loggedIn)
            return;
        const matches = pathsWithNoAuthRequired.filter(route => location.pathname.startsWith(route)).length > 0;
        if (!matches) {
            history.replace(loginPath);
        }
    });
    const value = React.useMemo(() => ({
        requiresAuth: selectedChannel.requiresAuth,
        loggedIn,
        updateLoggedIn: (loggedIn, token) => {
            if (loggedIn) {
                if (!token) {
                    throw new Error('No log in token provided');
                }
                props.auth.setAuthToken(token);
            }
            else {
                props.auth.clearAuthToken();
            }
            client
                .resetStore()
                .then(() => setLoggedIn(loggedIn))
                .catch(() => setLoggedIn(loggedIn));
        }
    }), [client, loggedIn, props.auth, selectedChannel.requiresAuth]);
    return React.createElement(AuthContext.Provider, Object.assign({ value: value }, props));
};
export default withCookies(AuthProvider);
//# sourceMappingURL=AuthProvider.js.map